import React from "react";
import LandingPage from "./components/LandingPage";
import TermsPage from "./components/TermsPage";
import PrivacyPage from "./components/PrivacyPage";
import CreditTermsPage from "./components/CreditTermsPage";
import CollaborationInviteAccept from "./components/CollaborationInviteAccept";
import BlogPage from "./components/BlogPage";
import VirtualStagingBlog from "./components/VirtualStagingBlog";
import VirtualStagingBlogPost from "./components/VirtualStagingBlogPost";
import FlowBlog from "./components/FlowBlog";
import FlowBlogPost from "./components/FlowBlogPost";
import SocialOAuthCallback from "./components/marketing/SocialOAuthCallback";
import AccessCodePage from "./components/AccessCodePage";
import FlowLandingPage from "./components/FlowLandingPage";
import PropertyGalleryPage from "./components/PropertyGalleryPage";
import AgentPortfolioPage from "./components/AgentPortfolioPage";
import {
  VirtualStagingFeaturePage,
  VideoReelsFeaturePage,
  BatchProcessingFeaturePage,
  LandingPagesFeaturePage,
  PortfolioFeaturePage,
  ReferEarnFeaturePage
} from "./components/FlowFeaturePages";
import LabApp from "./components/lab/LabApp";

const App = () => {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";

  // Lab feature (Ultra-only) — handles /lab and all /lab/* subroutes
  if (path.toLowerCase() === "/lab" || path.toLowerCase().startsWith("/lab/")) {
    return <LabApp />;
  }

  // Flow Blog - Individual post (must be before /flow/blog)
  if (path.toLowerCase().startsWith("/flow/blog/")) {
    const slug = path.replace(/^\/flow\/blog\//i, "");
    return <FlowBlogPost slug={slug} />;
  }

  // Flow Blog - List page
  if (path.toLowerCase() === "/flow/blog") {
    return <FlowBlog />;
  }

  // Flow - Virtual Staging landing page (case-insensitive, exact match)
  if (path.toLowerCase() === "/flow") {
    return <FlowLandingPage />;
  }

  // Flow Feature Pages - Must be before generic /flow/:galleryId route
  if (path.toLowerCase() === "/flow/features/virtual-staging") {
    return <VirtualStagingFeaturePage />;
  }
  if (path.toLowerCase() === "/flow/features/video-reels") {
    return <VideoReelsFeaturePage />;
  }
  if (path.toLowerCase() === "/flow/features/batch-processing") {
    return <BatchProcessingFeaturePage />;
  }
  if (path.toLowerCase() === "/flow/features/landing-pages") {
    return <LandingPagesFeaturePage />;
  }
  if (path.toLowerCase() === "/flow/features/portfolio") {
    return <PortfolioFeaturePage />;
  }
  if (path.toLowerCase() === "/flow/features/refer-earn") {
    return <ReferEarnFeaturePage />;
  }

  // Agent Portfolio Page - Public page showing all listings from an agent
  // Must be before generic /flow/:galleryId route
  if (path.toLowerCase().startsWith("/flow/agent/")) {
    const agentSlug = path.replace(/^\/flow\/agent\//i, "");
    return <AgentPortfolioPage agentSlug={agentSlug} />;
  }

  // Property Gallery - Public shareable page (must be after /flow exact match)
  if (path.toLowerCase().startsWith("/flow/")) {
    const galleryId = path.replace(/^\/flow\//i, "");
    return <PropertyGalleryPage galleryId={galleryId} />;
  }

  if (path.startsWith("/terms")) {
    return <TermsPage />;
  }

  if (path.startsWith("/privacy")) {
    return <PrivacyPage />;
  }

  if (path.startsWith("/credit-terms")) {
    return <CreditTermsPage />;
  }

  // Virtual Staging Blog (local content)
  if (path.startsWith("/staging-blog/")) {
    // Individual blog post - extract slug
    const slug = path.replace("/staging-blog/", "");
    return <VirtualStagingBlogPost slug={slug} />;
  }

  if (path === "/staging-blog") {
    return <VirtualStagingBlog />;
  }

  if (path.startsWith("/blog")) {
    return <BlogPage />;
  }

  if (path.startsWith("/collaboration/invite")) {
    return <CollaborationInviteAccept />;
  }

  // Handle Social Media OAuth callback routes
  // Pattern: /integrations/social/:platform (e.g., /integrations/social/facebook)
  if (path.startsWith("/integrations/social/")) {
    return <SocialOAuthCallback />;
  }

  // Lead access code redemption page
  if (path.startsWith("/leads/access")) {
    return <AccessCodePage />;
  }

  return <LandingPage />;
};

export default App;
